import { render } from "./NilampediaView.vue?vue&type=template&id=6fd3f6c4&scoped=true"
import script from "./NilampediaView.vue?vue&type=script&lang=js"
export * from "./NilampediaView.vue?vue&type=script&lang=js"

import "@/assets/css/about.css?vue&type=style&index=0&id=6fd3f6c4&scoped=true&lang=css"
import "./NilampediaView.vue?vue&type=style&index=1&id=6fd3f6c4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd3f6c4"]])

export default __exports__